import React from 'react'
import Icon from './Icon'
import PropTypes from 'prop-types'

class PowerButtonGreen extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg width='20px' height='20px' className='icon'>
          <image
            width='16px'
            height='16px'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAMAAAAL34HQAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
            AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABblBMVEUAAAAAqlUAs1EAr1AA
            sVAAsFAAr1AAsFAAsFAAsFAAsFAAsFAAsFAAr1AAsFAAsk0AsE8AsFAAsU4AsE8AsE8Ar1AAslIA
            r1AAs00Ar1AAsVAAsVAAsVEAqlUAsFEAsVAAr1AAqlUAsE8AsFAAs00Ar1AAsFAAsVAAsE8AsFEA
            sFAAr1AAsFEAslEAsFAAr1AAsFAAsFEAsE8AsFAAsFAAr1AAsFIAsFEAtVIAsU4AsVAAsFAAslAA
            rlEAsVAAsFAAsFAAsFAAsFBw050QtVvw+vX////1/Pggumbr+fHm9+5gzpJQyYeH2q3z+/ed4byx
            58rx+/VAxHz4/frL79vD7db3/fr2/Pnb9Ofb9ObI7tm+69Ph9uswv3Hk9+30/Pdq0Zjv+vTp+PDP
            8N551aO56c/e9enT8uHn9++r5cbq+PHt+fO36c6W37fX8+SA16eP3LPf9en5/fvN8N2l48Gk48HY
            8+Tj9uz3/fnS8eBefKmKAAAAQnRSTlMACS9WfJ+suMXS3+z5uawhYZIaWpraNY0eds3+dQNetrYM
            eukUg/LxHYv6+n5P0yCl+lHr/epRhR8++/tgcurW3OFasb3xAAAAAWJLR0RGF7r57QAAAAlwSFlz
            AAAXEQAAFxEByibzPwAAAAd0SU1FB+QBFxADCf94/bUAAAeSSURBVHjazZz5Q9NIFMfDWVruQ2lZ
            DkUBQRGFRcVzd0jTFnpAkVbEImCltQXX1d1197/fpKXNJG2S92Ymbb6/QZPMJzOTN2/ezBtJ4lNH
            Z1d3T6+vzx/oHxjoD/j7Bod6urs6Ozgfy6HhkVFfgFgo4BsdGW450tj4xA3iqBsT42OtY7o56XdG
            qsk/ebMVTMHQlFrYL3AuQqamg+4yzczOYXh03ZqdcQ3q9vwdNihNd+ZvuwJ1d2GRHUrT0sJd4VD3
            llf4oDTdX74nluoBP1NVDwRCrT4URUXIw1VBUGuPxEFperQmgir0WCwVISshbqggo6Gy1xynfV3f
            IL+6wbX5hIfqqRtIVT1lhnrmc4+KEB9jz9/adKcBa9rcYqFafe4mk6YXDCbspdtQml5iqV61goqQ
            VziqhdZQEbLgSSoUV4tasCpwO7akt+sC9vvV1lIRArITW67bK7NeAOzq2marqVR7/8wRy9Vx0Eo+
            JyoXfQY7OfgTT9pDRci6HVVwo11Ym3b+qiseMkxz1lQhdx0se1nOO9aEz3EwWrHyVgXPB7F61JyK
            Z9DZ1sX+kOaDEMeMXg4rNUWizE952IyKJ/ohx+pYO+xYzeIm9zioRGGRxjjTshewls1Ud7miaqKw
            7pvjhXzeuygss2d/my8uKgxryRj3neeiEodF5mmqGY7ItlisO3T8fpaPSiAWmaWwbuFv34VgyXH0
            cykHJ4inSiRTAKxEJIF+su4PTmNvlff2lWTaESsdUw7eYp+t+11TWKrDjAqQlR2w5Hfq35kjGffw
            qRrVTSRV9H2kQnDsgJXKVv7zAfkR1NYfJ3G35U4+Xvsw9Q7dFOu09s9sDvX8yWssxFqqhnBSRwjX
            EJphRc8YfTB/lWoMR3X4sV6ccm6NJX+irjtCFVFd3x5H3ZM60EtTDlKWWPl96rrMZ0wR4xWsCcwt
            8TOF1vXX2IglnxuuC2Ps6kQFC7BzoK7KN19X8qTWYo21Fb0wcEUQhdzQqIYxlZXI0FVVsOvy8hGN
            lUkhStH2dYxgKqtIl1SoG8rmduuYfock4mscUbFGWSur4GTlySe6vr7AixmVUHE2me7vJcpIWmDJ
            9NdYhg9CWhQuAL6a5CmscJ7mtfAg4kmqzeHz7YAkdcCpSIHq7peGarRyAz+zfYwdUif84qg+pVeK
            hiaxxJJL+i0xeKfvlLrgWHmqw+8ZfrF2mq+o2sqDS+qSuuFY7/UidtJALNqkfACX1C31wLF010H5
            avzFZoqh/6IUwSX1SEPga3N6CRmTi26DtasbiRjY7+qVBsFY8X3Lsm2wqE5/ADYRPqkPjJXXm2Pf
            9JPdPJGydeBpUB/CNU1R3zoC68Lq87WRH2Hk9/TnFxBYlA0+hBYVkPrBWIf6883Drh3WlfXbWKpf
            GgBjUa9tdp5kpVRTgy3/g8FwDSCwLq2x7PSNobYGEI14xdBJiKFLgrt8P6LLJyyNvK0OGSo5gDAQ
            8Uz9+VkEFjX67ELv8SPMabxcfz7CMZf/1I0weFbWh/CZo/p7w4cResgKp6E3DUq98Pem5tPvwXcd
            U0MWuI6HMI4NZSGS0PkC7W/B36UH4wbu6qMueL5AzUoy8IBlN8ZppluxCGsQegqH8OW7MFMMeviJ
            wGaj9Hz3Al5QJ2pCdqpQvQvy7lFq4pP9Bi+oAzV9lb9TXOeA639QoTfEOkIAN9knf1FYinNo+zhL
            Vdbf8GJ8yNCIIQjx/crh6jzVhEoJEbEZRQaSyCnNFbYdeuWrHepahHWoBpJQYTd64FXHoH+srap8
            TIdrTMEBBw1jg5QkHqYLU8pWU7/0SYS+bh8+0b8OUuJCuoYYjGYjvzTrM7kvO4arspeYyppgCICT
            IyOXkkyZayyX+hkxXlNArfuMMywXEPmDiUuJZVPp+q/pxLtk1nTBGW7VZ4xlcYXkvisNKpb/jR1e
            Fk7KpXDjjz9xi51+tqUokm5StI1ip7jHTzIu3JH0AYKqhKSqL9yhlzlJ7gIKlf2KW7WjljmlEBbL
            bCwtdYD7BjVN8yyhk6sygCqZQlNRS+hMOyhze049P/YJ24CqbnFvz0ifJ22gSv/hN0EQ4/YM1s0s
            u+VYc6bI2bs8vv1UvTYko86zYak1tl0ompky4R8JhuaryLD1h2ujlLxdODsrxtQGzZZi4dLJW2Ym
            QhZNCbK8SSFyLr67vZ3OMbWcLnPCCN8mPFFaaUja5dqyKEoNWxb5NniKUpNEYmHJwOxqmkYsMB2Y
            TW+aUbU+v8csi3wfb25Mb/M2/seWSad4v0ugbJKtvZkiIgXbkKlV1YZtAvh6u7Ac0r+9mazl1dQ2
            6VkbutcGICG99WmTz0Hp6N5MMvVqSq5XE5i9mu7t1eR4rx4l4NWDF1Q78cJtqOdMJ+1suWzvN5gO
            9VC9VXePQHFOPbeSJw+MUfXEpYbcWOeh8uphRKpCwoMmj/mPbpK8etCVJPZYsDeijgXT5MlD1CTt
            yLn7/Ewroo+ck7QD+pb4oBZdOKBPE9dxhq9dOs5Q08wsQ4KlpjkXD3+sKDiNXk+bCrl8VGZVXjxY
            tCrYMay/tfQY1mvZHlr7e1sOra2rcsTv0KB+xK+vV8QRv/8D1y78Nm2cMJoAAAAldEVYdGRhdGU6
            Y3JlYXRlADIwMjAtMDEtMjNUMTY6MDM6MDkrMDM6MDB3eq0KAAAAJXRFWHRkYXRlOm1vZGlmeQAy
            MDIwLTAxLTIzVDE2OjAzOjA5KzAzOjAwBicVtgAAAABJRU5ErkJggg=='
          />
        </svg>
      </Icon>
    )
  }
}

PowerButtonGreen.propTypes = {
  bigIcon: PropTypes.bool
}

export default PowerButtonGreen
